import { render, staticRenderFns } from "./SettingsPersonal.vue?vue&type=template&id=21f69f42&scoped=true&"
import script from "./SettingsPersonal.vue?vue&type=script&lang=js&"
export * from "./SettingsPersonal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPersonal.vue?vue&type=style&index=0&id=21f69f42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f69f42",
  null
  
)

export default component.exports